export const wordsList = {
    carro: ["Motor", "Porta", "Capô", "Pneu", "Antena", "Poltrona", "Volante"],
    fruta: ["Banana", "Maçã", "Pêra", "Mamão", "Laranja", "Uva", "Goiaba", "Cacau"],
    corpo: ["Braço", "Perna", "Cérebro", "Pescoço", "Olhos", "Boca", "Orelha"],
    computador: ["Mouse", "Teclado", "Monitor", "Gabinete"],
    programação: ["Linguagem", "Framework", "JavaScript", "React", "Node", "Angula", "Vue"],
    alimento: ["Arroz", "Feijão", "Carne", "Leite", "Ovo", "Peixe", "Lasanha"],
    animal: ["Cavalo", "Cachorro", "Zebra"]
  };